/* KONNI39 · Xử lý đơn hàng sàn — khởi động
   Luồng: đăng nhập máy → load_active (RAM) → tab 1 nạp / tab 4 export.
   Tab 2–3 (pick/out) nối ở GĐ3 theo docs/03-KIEN-TRUC.md mục 5. */
import { S, loadActive, setSync, startRealtime } from './store.js';
import { queueInit, pending, pendingKeys, lastAck } from './lib/queue.js';
import { sb, signIn, signOut, getSession } from './lib/supabase.js';
import { $, $$, esc, log, DIAG, downloadText, SOUND, kvGet, kvSet } from './lib/ui.js';
import { initTab1, restoreDir, afterLoad, onData } from './tabs/tab1.js';
import { initTab2, pkEnter, pkRefresh, pkOpenKeys, restoreDraft, pkExternalChange } from './tabs/tab2.js';
import { initTab3, otEnter, otRefresh, otServerReject } from './tabs/tab3.js';
import { initTab4, exEnter } from './tabs/tab4.js';

const APP_VERSION = '5.1.0';

function showTab(v) {
  $$('.tab').forEach((t) => t.classList.toggle('sel', t.dataset.v === v));
  $$('.view').forEach((s) => s.classList.toggle('sel', s.id === v));
  if (v === 'v2') pkEnter();
  if (v === 'v3') otEnter();
  if (v === 'v4') exEnter();
}
$('#tabs').addEventListener('click', (e) => {
  const b = e.target.closest('.tab'); if (!b || b.disabled) return;
  showTab(b.dataset.v);
});

/* ---------- đăng nhập ---------- */
$('#loginForm').onsubmit = async (e) => {
  e.preventDefault();
  const btn = $('#loginBtn'); btn.disabled = true; btn.textContent = 'Đang đăng nhập…';
  $('#loginMsg').innerHTML = '';
  try {
    await signIn($('#loginEmail').value.trim(), $('#loginPass').value);
    await boot();
  } catch (err) {
    $('#loginMsg').innerHTML = '<div class="note e"><span class="ic">!</span><div>' + esc(err.message) + '</div></div>';
  } finally { btn.disabled = false; btn.textContent = 'Đăng nhập'; }
};
$('#btnLogout').onclick = async () => {
  await signOut();
  location.reload();
};

function showLogin(msg) {
  $('#app').style.display = 'none';
  $('#login').style.display = '';
  if (msg) $('#loginMsg').innerHTML = '<div class="note w"><span class="ic">!</span><div>' + esc(msg) + '</div></div>';
  setTimeout(() => $('#loginEmail').focus(), 50);
}

/* ---------- khởi động sau đăng nhập ---------- */
async function boot() {
  $('#login').style.display = 'none';
  $('#app').style.display = '';
  log('Bản ' + APP_VERSION + ' · ' + location.host, 'ok');
  try {
    await loadActive();
  } catch (e) {
    setSync('off', 'lỗi');
    log('Không tải được dữ liệu: ' + e.message, 'er');
    if (/chưa được gắn tên máy|Chưa đăng nhập/.test(e.message)) { await signOut(); showLogin(e.message); return; }
    $('#sessBox').innerHTML = '<div class="note e"><span class="ic">!</span><div>' + esc(e.message) + '</div></div>';
    $('#rowSetup').style.display = '';
    return;
  }
  $('#mayLbl').textContent = S.may;
  await queueInit({
    onChange: (n, sending) => {
      if (n) { setSync('busy', (sending ? 'đang gửi · ' : 'chờ gửi · ') + n + ' thao tác'); $('#pkSaved').textContent = n + ' thao tác chờ gửi'; $('#pkSaved').classList.remove('on'); }
      else if (!navigator.onLine) setSync('off', 'mất mạng');
      else { setSync('ok', 'đã đồng bộ' + (lastAck() ? ' ' + lastAck().toLocaleTimeString('vi-VN') : '')); }
    },
    onAck: (op, data, ms) => {
      const t = new Date().toLocaleTimeString('vi-VN');
      $('#pkSaved').textContent = 'đã ghi ' + t + ' · ' + ms + ' ms'; $('#pkSaved').classList.add('on');
      $('#otSaved').textContent = 'đã ghi ' + t; $('#otSaved').classList.add('on');
    },
    onError: (op, data) => {
      if (op.rpc === 'do_out') otServerReject(op, data);
      else log('Máy chủ từ chối ' + op.label + ': ' + (data.code || data.message || '?'), 'er');
    }
  });
  startRealtime((ev, key, o) => {
    if (ev === 'skipped') { if (pkOpenKeys().includes(key)) pkExternalChange(key, o); return; }
    if ($('#v2').classList.contains('sel')) pkRefresh();
    if ($('#v3').classList.contains('sel')) otRefresh();
    if ($('#v4').classList.contains('sel')) exEnter();
  }, (key) => pkOpenKeys().includes(key) || pendingKeys().has(key));
  await restoreDir();
  await afterLoad();
  await restoreDraft();
}

/* ---------- chẩn đoán ---------- */
$('#btnDiag').onclick = () => {
  const L = [];
  const sec = (t) => L.push('', '===== ' + t + ' =====');
  sec('MOI TRUONG');
  L.push('Ban app        : ' + APP_VERSION);
  L.push('Thoi diem xuat : ' + new Date().toISOString());
  L.push('Phien mo app   : ' + DIAG.started);
  L.push('URL            : ' + location.href);
  L.push('User agent     : ' + navigator.userAgent);
  L.push('Man hinh       : ' + screen.width + 'x' + screen.height + ' | cua so ' + innerWidth + 'x' + innerHeight);
  L.push('File System Access : ' + (('showDirectoryPicker' in window) ? 'co' : 'KHONG'));
  L.push('Online         : ' + navigator.onLine);
  sec('MAY & DU LIEU');
  L.push('May            : ' + (S.may || '—'));
  L.push('Tai luc        : ' + (S.loadedAt ? S.loadedAt.toISOString() : '—'));
  L.push('Don trong RAM  : ' + Object.keys(S.orders).length);
  L.push('Dem tren may chu: ' + JSON.stringify(S.counts));
  if (S.sum) L.push('Nhom           : ' + JSON.stringify(S.sum.byGroup));
  sec('LOI DA BAT (' + DIAG.errors.length + ')');
  if (!DIAG.errors.length) L.push('(khong co)');
  DIAG.errors.forEach((e, i) => {
    L.push('--- loi #' + (i + 1) + ' ---', 'luc   : ' + e.t, 'cho   : ' + e.where, 'ten   : ' + e.name, 'noi dung: ' + e.msg);
    if (e.stack) L.push('stack :', e.stack);
  });
  sec('NHAT KY (' + DIAG.lines.length + ' dong)');
  const name = 'konni39-chandoan-' + new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19) + '.txt';
  downloadText(name, L.concat(DIAG.lines).join('\n'));
  log('Đã tải nhật ký chẩn đoán: ' + name, 'ok');
};

/* ---------- vào ---------- */
(async function () {
  initTab1(() => showTab('v2'));
  onData(() => { pkRefresh(); });
  initTab2(); initTab3(); initTab4();
  $('#pkSound').onclick = function () { SOUND.on = !SOUND.on; this.textContent = 'Âm thanh: ' + (SOUND.on ? 'bật' : 'tắt'); kvSet('sound', SOUND.on); };
  try { const snd = await kvGet('sound'); if (snd === false) { SOUND.on = false; $('#pkSound').textContent = 'Âm thanh: tắt'; } } catch (e) { }

  const sess = await getSession();
  if (sess) await boot(); else showLogin();

  sb.auth.onAuthStateChange((ev) => {
    if (ev === 'SIGNED_OUT') showLogin('Đã đăng xuất');
  });
})();
